export const PARTNER_PRODUCT_PRICE_SUGGESTION_TABLE =
  "partnerProductPriceSuggestions"
export const PARTNER_PRODUCT_PRICE_SUGGESTION_TABLE_SCHEMA =
  "id, companyId, targetId, syncId"
